import { CDN_ASSET_IDS } from "../config/cdn-assets";

// Matches any Contentful CDN domain: videos, downloads, assets, images (non-image-API)
const CTFASSETS_RE = /(?:videos|downloads|assets)\.ctfassets\.net\/[^/]+\/([^/]+)\/[^/]+\/([^/?#]+)/;

/**
 * If a Contentful asset URL is in the CDN_ASSET_IDS list, returns the local
 * static path served from Netlify CDN. Otherwise returns the original URL.
 *
 * @param {string} url - The asset URL from Contentful
 * @returns {string} Resolved URL
 */
export function resolveAssetUrl(url) {
  if (!url) return url;
  const match = url.match(CTFASSETS_RE);
  if (match && CDN_ASSET_IDS.includes(match[1])) {
    return `/cdn/${match[1]}/${match[2]}`;
  }
  return url;
}
